import { gql } from "@apollo/client";

export const compneyState = {
  companyName: "",

  registrationNumber: "",

  address: "",

  contactNumber: "",

  fiscalYear: "",

  currency: "",

  dateFormat: "",

  companyLogo: null,

  companyNameStatus: "unchecked",

  registrationNumberStatus: "unchecked",

  addressStatus: "unchecked",

  contactNumberStatus: "unchecked",

  fiscalYearStatus: "unchecked",

  currencyStatus: "unchecked",

  dateFormatStatus: "unchecked",

  companyLogoStatus: false,
};

export const compneyStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "companyName": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          companyName: value,
          companyNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          companyName: "",
          companyNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          companyName: value,
          companyNameStatus: "error",
        };
      }
    }
    case "registrationNumber": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          registrationNumber: value,
          registrationNumberStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          registrationNumber: "",
          registrationNumberStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          registrationNumber: value,
          registrationNumberStatus: "error",
        };
      }
    }
    case "address": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          address: value,
          addressStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          address: "",
          addressStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          address: value,
          addressStatus: "error",
        };
      }
    }
    case "contactNumber": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          contactNumber: value,
          contactNumberStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          contactNumber: "",
          contactNumberStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          contactNumber: value,
          contactNumberStatus: "error",
        };
      }
    }
    case "fiscalYear": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          fiscalYear: value,
          fiscalYearStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          fiscalYear: "",
          fiscalYearStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          fiscalYear: value,
          fiscalYearStatus: "error",
        };
      }
    }
    case "currency": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          currency: value,
          currencyStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          currency: "",
          currencyStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          currency: value,
          currencyStatus: "error",
        };
      }
    }
    case "dateFormat": {
      const alphaNLenghthRegex = new RegExp("^(.{1,100})$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          dateFormat: value,
          dateFormatStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          dateFormat: "",
          dateFormatStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          dateFormat: value,
          dateFormatStatus: "error",
        };
      }
    }
    case "companyLogo": {
      if (value) {
        return {
          ...state,
          companyLogo: value,
          companyLogoStatus: true,
        };
      } else if (!value) {
        return {
          ...state,
          companyLogo: null,
          companyLogoStatus: false,
        };
      }
    }
    default:
      return state;
  }
};

export const allCompanyDetails = gql`
  query {
    allCompanyDetails {
      companyDetails {
        id

        user {
          id
          employeeName
        }

        companyName

        registrationNumber

        address

        contactNumber

        fiscalYear

        currency

        dateFormat

        companyLogo

        createdAt

        lastupdate
      }

      success

      error

      message
    }
  }
`;
export const createCompanyDetails = gql`
  mutation createcomapnydetails($input: CreateCompanyDetailsInput!) {
    createCompanyDetails(input: $input) {
      success

      message
    }
  }
`;

export const updateCompanyDetails = gql`
  mutation updatecompanydetails($input: UpdateCompanyDetailsInput!) {
    updateCompanyDetails(input: $input) {
      success

      message
    }
  }
`;
